import * as React from 'react';
import { TealiumService } from './service.js';

const TealiumContext = /*#__PURE__*/ React.createContext(null);
TealiumContext.displayName = 'TealiumContext';
const TealiumProvider = (props)=>{
    const { sdkUrl , children  } = props;
    // Based on EL request we have disabled cookie checks: CXIB-1359
    const ref1 = React.useRef(TealiumService.createInstance(sdkUrl));
    React.useEffect(()=>{
        var ref;
        const cleanup = (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.listen();
        return cleanup;
    }, []);
    React.useEffect(()=>{
        const service = ref1.current;
        service === null || service === void 0 ? void 0 : service.load();
        return ()=>{
            service === null || service === void 0 ? void 0 : service.teardown();
        };
    }, []);
    return /*#__PURE__*/ React.createElement(TealiumContext.Provider, {
        value: null
    }, children);
};

export { TealiumProvider };
//# sourceMappingURL=provider.js.map
